import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-12 h-12  rounded-xl shadow-subtle">
            <img src="assets/images/logo2x.png"></img>
          </div>
          <h1 className="text-2xl font-semibold text-foreground">Expense<span className="text-primary">Loop</span></h1>
        </div>
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-foreground">
          Welcome Back
        </h2>
        <p className="text-muted-foreground">
          Sign in to your account to manage your shared expenses
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;